import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { BmxPropertyConfiguration, BMXTenant, getTenants } from '../../../../../api/PropertyIntegration';
import Button from '../../../../common/form/Button';
// import { bmxConfig } from '../../../../../api/Shared';
import { useState } from 'react';
import Modal from 'reactstrap/lib/Modal';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: BmxPropertyConfiguration;
    update: (newConfig?: BmxPropertyConfiguration) => void;
    propertyId: number;
}


const BmxConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | undefined>(undefined);
    const [tenantList, setTenantList] = useState([] as BMXTenant[] | undefined);
    const handleTenantViewList = async () => {

        setModalOpen(true);
        setIsLoading(true);

        let tenantListResult = await getTenants();
        if (tenantListResult.success && tenantListResult.data) {
            setTenantList(tenantListResult.data);
            // tenantList?.sort((a, b) => {
            //     if (a.buildingName < b.buildingName) {
            //         return -1;
            //     }
            //     if (a.buildingName > b.buildingName) {
            //         return 1;
            //     }
            //     return 0;
            // });

        } else if (tenantListResult.error) {
            setError(tenantListResult.error);
            console.log(error);
        } else {
            setTenantList([]);
        }
        setIsLoading(false);
        //console.log(tenantList);

    };

    const close = () => {
        setModalOpen(false);
        setError(undefined);
    };

    // const handleButterflyMXLogin = async () => {

    //     //TODO move this from front end to backend
    //     // const clientId = 'c8a0f39572fdbee4a33e320ecb63011ad66eecda0600273955015dcd111ed180';
    //     // const clientSecret = '1cacde46e5e81a3d58917741b3bc72f5254c4200c77e4ac9c02f97ee4073218a';

    //     // //TODO replace this with relative url and attach property id to this
    //     // const redirectUri = 'urn:ietf:wg:oauth:2.0:oob';
    //     // const responseType = 'code';

    //     //TODO Read this url from bmx config properties
    //     if (bmxConfig.env == "local" || bmxConfig.env == "dev") {
    //         const authUrl = `http://accountssandbox.butterflymx.com/oauth/authorize?prompt=login&client_id=${bmxConfig.clientId}&redirect_uri=${bmxConfig.redirectUri}&client_secret=${bmxConfig.clientSecret}&response_type=${bmxConfig.responseType}`;
    //         window.open(authUrl);
    //     } else {
    //         const authUrl = `http://accountssandbox.butterflymx.com/oauth/authorize?prompt=login&client_id=${bmxConfig.clientId}&redirect_uri=${bmxConfig.redirectUri}?propertyid=${props.propertyId}&client_secret=${bmxConfig.clientSecret}&response_type=${bmxConfig.responseType}`;
    //         window.location.href = authUrl;
    //     }

    // };

    return (
        <CollapsibleCard
            cardTitle="Bmx Access"
            cardOpen={!!props.config}
            onCardOpenChange={newValue =>{
                if (isUser)  return; props.update(newValue ? { buildingId: '', tenantId: '', email: '' } : undefined)}}
        >
            <div>
                {props.config && (
                    <>
                        {/*                         <FormInput
                            labelProps={{
                                labelText: 'Tenant Email'
                            }}
                            inputProps={{
                                id: 'bmx-tenant-email',
                                name: 'emailId',
                                value: props.config.email || '',
                                type: 'string'

                            }}
                            onChange={(_name, value) =>
                                props.update({ ...props.config!, email: value.toString() })
                            }
                        /> */}
                        <FormInput
                            labelProps={{
                                labelText: 'TenantId'
                            }}
                            inputProps={{
                                id: 'bmx-tenant-id',
                                name: 'tenantId',
                                value: props.config.tenantId || '',
                                type: 'string',
                                disabled: isUser

                            }}
                            onChange={(_name, value) =>
                                !isUser && props.update({ ...props.config!, tenantId: value.toString() })
                            }
                        />
                        <Button
                            text="View Tenant List"
                            onClick={handleTenantViewList}
                            addlClassName="btn-primary"
                            disabled={isUser}
                        >
                        </Button>
                        <Modal size="lg" isOpen={modalOpen} toggle={close} className="bmx-tenant-modal">
                            <LoadingOverlay show={loading} inBootstrapColumn={false} />
                            <ModalHeader toggle={close}>BMX Tenant List</ModalHeader>
                            <ModalBody>
                                {!loading && (
                                    <Container>
                                        <Row className="bmx-tenant-row">
                                            <Col md={2}>
                                                <span className="item"> Property Id </span>
                                            </Col>
                                            <Col md={3}>
                                                <span className="item">Property Name</span>
                                            </Col>
                                            <Col md={4}>
                                                <span className="item">Address </span>
                                            </Col>
                                            <Col md={2}>
                                                <span className="item">Tenant Id </span>
                                            </Col>
                                            <Col md={1}>
                                                <span className="item">Unit Id </span>
                                            </Col>
                                        </Row>
                                        {tenantList && (
                                            tenantList.map((tenant, index) => {
                                                return (
                                                    <Row className="bmx-tenant-row">
                                                        <Col md={2}>
                                                            <span className="item"> {tenant.buildingId} </span>
                                                        </Col>
                                                        <Col md={3}>
                                                            <span className="item"> {tenant.buildingName} </span>
                                                        </Col>
                                                        <Col md={4}>
                                                            <span className="item">{tenant.buildingAddress} </span>
                                                        </Col>
                                                        <Col md={2}>
                                                            <span className="item">{tenant.tenantId} </span>
                                                        </Col>
                                                        <Col md={1}>
                                                            <span className="item">{tenant.unitId} </span>
                                                        </Col>
                                                    </Row>
                                                )
                                            }
                                            )
                                        )}
                                    </Container>
                                )}
                            </ModalBody>
                        </Modal>

                    </>
                )}
            </div>
        </CollapsibleCard>
    );
}

export default BmxConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/BmxConfigurationSection.tsx